module.exports = __webpack_public_path__ + "img/flow-num-3.e9596f4e.svg";